module.exports = __webpack_public_path__ + "static/media/dsu_logo.991c9ff6.svg";